/* CUSTOM:START VariantDeliveryMessaging */
class VariantDeliveryMessaging {
    static async init() {
        this.variantsData = {};
        this.selectedVariant = null;
        this.countdownInterval = null;
        try {
            const liquidData = JSON.parse(
                document.getElementById('variant-delivery-messaging__variants_data').textContent
            );
            this.variantsData = liquidData.variants;
            this.selectedVariant = this.variantsData[liquidData.selected_or_first_available_variant] || null;
            document.addEventListener('on:variant:change', this.onVariantChange.bind(this));

            document.addEventListener('click', (e) => {
                const el = e.target.closest('[data-action="vdm-change-zip"]');
                if (!el) return;
                e.preventDefault();
                VariantDeliveryMessaging.promptForClientZip(); // static call; no `this` needed
            });
        } catch (e) {
            console.error(e);
        }
        await this.generateDeliveryMessaging();
    }

    static async onVariantChange(evt) {
        this.selectedVariant = evt.detail?.variant?.id;
        this.selectedVariant = this.variantsData[this.selectedVariant] || null;
        await this.generateDeliveryMessaging();
    }

    static async promptForClientZip() {
        const zip = prompt('Enter your zip code', localStorage.getItem('syl_user_zip') || '');
        if (zip !== null) {
            await this.updateClientZip(zip);
        }
    }

    static async updateClientZip(zip) {
        const usZipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
        const caPostalRegex =
            /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;

        if (!usZipRegex.test(zip) && !caPostalRegex.test(zip)) {
            alert('Please enter a valid US ZIP or Canadian postal code');
            return;
        }

        if (window.localStorage.getItem('syl_user_zip') === zip) {
            return;
        }
        localStorage.setItem('syl_user_zip', zip);
        await this.generateDeliveryMessaging();
    }

    static async generateDeliveryMessaging() {
        // Clear any existing countdown interval
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }

        const stockMessageEl = document.getElementById('variant-delivery-messaging__stock_message');
        const freeDeliveryMessageEl = document.getElementById('variant-delivery-messaging__free_delivery_message');
        try {
            if (stockMessageEl) {
                stockMessageEl.innerHTML = '';
            }
            if (freeDeliveryMessageEl) {
                freeDeliveryMessageEl.innerHTML = '';
            }
            this.selectedVariant.is_preorder = this.selectedVariant.available && this.selectedVariant.is_preorder;
            let stockMessageHTML;
            let freeDeliveryMessageHTML = `Free ${this.selectedVariant.ships_freight ? 'Freight' : 'Standard'} Delivery${this.selectedVariant.price < 45 ? ' on orders over $45' : ''}`;

            if (this.selectedVariant.is_discontinued) {
                stockMessageHTML = 'This product is discontinued.';
            } else if (this.selectedVariant.available === false) {
                stockMessageHTML = 'This item is currently Out of Stock.';
                freeDeliveryMessageHTML = undefined;
            } else if (this.selectedVariant.is_dropship) {
                stockMessageHTML = `<span class="in-stock-indicator">In Stock</span>`;
                if(this.selectedVariant.dship_lead_time >= 21) {
                    stockMessageHTML += `<strong> Usually ships in 4 to 6 weeks.</strong>`;
                } else if(this.selectedVariant.dship_lead_time >= 20) {
                    stockMessageHTML += `<strong> Usually ships in a month.</strong>`;
                } else if(this.selectedVariant.dship_lead_time >= 15) {
                    stockMessageHTML += `<strong> Usually ships in 2 to 3 weeks.</strong>`;
                } else if(this.selectedVariant.dship_lead_time >= 10) {
                    stockMessageHTML += `<strong> Usually ships in 2 weeks.</strong>`;
                } else if(this.selectedVariant.dship_lead_time >= 6) {
                    stockMessageHTML += `Usually ships in a week.`;
                } else if(this.selectedVariant.dship_lead_time >= 4) {
                    stockMessageHTML += `Usually ships in 3 to 5 business days.`;
                } else if(this.selectedVariant.dship_lead_time >= 3) {
                    stockMessageHTML += `Usually ships in 2 to 3 business days.`;
                } else if(this.selectedVariant.dship_lead_time >= 2) {
                    stockMessageHTML += `Usually ships in 1 to 2 business days.`;
                } else {
                    stockMessageHTML += `Usually ships in 24 hours.`;
                }
            } else if (this.selectedVariant.is_preorder) {
                stockMessageHTML = `<span class="pre-order-indicator">Pre-Order</span>` + (
                    this.selectedVariant.est_restock_date
                        ? `Shipping on ${ new Date(this.selectedVariant.est_restock_date).toLocaleDateString()} - Reserve Today!`
                        : 'Reserve today to ship out as soon as available!'
                );
            } else {
                try {
                    const debugCurrentDateTime = new URL(window.location.href).searchParams.get('debugCurrentDateTime');
                    const now = debugCurrentDateTime ? new Date(debugCurrentDateTime) : new Date();
                    const response = await fetch('https://syl-shipping-offer-worker.sylvane-discountbandit7106.workers.dev', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            variantId: this.selectedVariant.id,
                            zip: window.localStorage.getItem('syl_user_zip') || undefined,
                            currentDateTime: debugCurrentDateTime
                                ? now.toISOString()
                                : undefined,
                        })
                    });
                    const responseData = await response.json();
                    if (!responseData.success) {
                        if (responseData.error === 'Provided zip is invalid' ||
                            responseData.error === 'Provided postal code is invalid') {
                            localStorage.removeItem('syl_user_zip');
                        }
                        throw new Error(responseData.error || 'Unknown Error');
                    }

                   const {
                        pickupDate,
                        transitDays,
                        zip: responseZip,
                        country,
                        isInternational,
                        isAkOrHi,
                    } = responseData.data;

                    const target = new Date(pickupDate);
                    const transitDaysNum = typeof transitDays === 'number' ? transitDays : null;
                    const isCanada = country === 'CA' || isInternational === true;
                    const isAkOrHiDestination = isAkOrHi === true;

                    if (responseZip && localStorage.getItem('syl_user_zip') !== responseZip) {
                        localStorage.setItem('syl_user_zip', responseZip);
                    }

                    const isToday = target.toLocaleDateString() === now.toLocaleDateString();

                    const diffMs = target - now;
                    let timeLeftToShipToday = null;

                    if (isToday && diffMs > 0) {
                        // Start the countdown timer
                        this.startCountdown(target, debugCurrentDateTime);
                    } else {
                        const dateDisplay = target.toLocaleDateString(undefined, {
                            weekday: 'long',
                            month: 'long',
                            day: 'numeric',
                        });
                        stockMessageHTML =
                            `<span class="in-stock-indicator">In Stock</span>` +
                            `Order now! Ships on <strong>${dateDisplay}</strong>.`;
                    }

                    if (isCanada) {
                        freeDeliveryMessageHTML =
                            `Shipping, taxes, duties and fees calculated in checkout`;
                    } else if (isAkOrHiDestination) {
                        freeDeliveryMessageHTML =
                            `Shipping, taxes, duties and fees calculated in checkout`;
                    } else if (!this.selectedVariant.ships_freight && transitDaysNum !== null) {
                        if (transitDaysNum <= 3) {
                            const dayText =
                                transitDaysNum === 1 ? 'Next' :
                                transitDaysNum === 2 ? '2' :
                                '3';
                            freeDeliveryMessageHTML =
                                `Free ${dayText} Day Delivery` +
                                `${this.selectedVariant.price < 45 ? ' on orders over $45' : ''}`;
                        }
                    }
                } catch (e) {
                    console.error('[variant-delivery-messaging] Error: %o', e);
                }
            }

            if (stockMessageEl && stockMessageHTML) {
                stockMessageEl.innerHTML = stockMessageHTML;
            }

            if (freeDeliveryMessageEl && freeDeliveryMessageHTML) {
                freeDeliveryMessageEl.innerHTML = freeDeliveryMessageHTML;
                const zip = localStorage.getItem('syl_user_zip');
                if (zip) {
                    freeDeliveryMessageEl.innerHTML += ` to <span data-action="vdm-change-zip">${zip}</span>`;
                }
            }
        } catch (e) {
            console.error('[variant-delivery-messaging] Error: %o', e);
        }
    }

    static startCountdown(targetDate, debugCurrentDateTime) {
        const stockMessageEl = document.getElementById('variant-delivery-messaging__stock_message');
        if (!stockMessageEl) return;

        const updateCountdown = () => {
            const now = debugCurrentDateTime ? new Date(debugCurrentDateTime) : new Date();
            const diffMs = targetDate - now;

            if (diffMs <= 0) {
                // Countdown expired, clear interval
                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
                stockMessageEl.innerHTML = '<span class="in-stock-indicator">In Stock</span>Usually ships in 24 hours.';
                return;
            }

            const diffSecs = Math.floor(diffMs / 1000);
            const diffMins = Math.floor(diffSecs / 60);
            const diffHours = Math.floor(diffMins / 60);

            const hours = diffHours % 24;
            const minutes = diffMins % 60;
            const seconds = diffSecs % 60;

            let countdownHTML = '<span class="in-stock-indicator">In Stock</span>';
            countdownHTML += 'Want it shipped <span class="today">today</span>? Order within ';

            if (hours) {
                countdownHTML += `<span class="countdown">${hours} hour${hours !== 1 ? 's' : ''}</span> `;
            }
            if (minutes) {
                countdownHTML += `<span class="countdown">${minutes} minute${minutes !== 1 ? 's' : ''}</span> `;
            }
            if (seconds && !hours) {
                countdownHTML += `<span class="countdown">${seconds} second${seconds !== 1 ? 's' : ''}</span>`;
            }

            stockMessageEl.innerHTML = countdownHTML;
        };

        // Update immediately
        updateCountdown();

        // Then update every second
        this.countdownInterval = setInterval(updateCountdown, 1000);
    }
}

await VariantDeliveryMessaging.init();
/* CUSTOM:END VariantDeliveryMessaging */